(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3065],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 45578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 65182:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bylines/[...id]",
      function () {
        return __webpack_require__(94070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45578);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2962);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88518);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var src_2_0_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1903);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75519);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38864);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84233);
/* harmony import */ var src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(84920);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34892);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25283);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39334);
/* harmony import */ var src_utils_services__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(73113);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(51148);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(186);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  min-width: auto;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  margin-top: 30px;\n  .block-1 {\n    background-color: #edf4ff;\n    flex-direction: row;\n    display: flex;\n    width: 100%;\n    padding: 10px;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    position: relative;\n    justify-content: space-between;\n    border-radius: 16px;\n    @media (max-width: 425px) {\n      padding: 20px;\n      justify-content: center;\n      align-content: center;\n      flex-direction: column-reverse !important;\n    }\n\n    .title.line-clamp {\n      -webkit-line-clamp: 4;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      white-space: normal;\n      text-align: start;\n      @media (max-width: 425px) {\n        text-align: center;\n      }\n    }\n\n    .card-item {\n      &.--desktop {\n        padding-top: 15px;\n        max-width: 60%;\n        //width: 100%;\n        min-width: auto;\n        height: auto;\n        padding-left: 10px;\n        padding-right: 10px;\n\n        @media (max-width: 390px) {\n          width: 100%;\n        }\n        @media (max-width: 597px) {\n          width: 100%;\n          max-width: 100%;\n        }\n      }\n      &.--mobile {\n        width: 100%;\n        padding: 8px 0 8px;\n        &:nth-child(5) {\n          padding: 8px 0 0;\n          .card-h .card-content {\n            padding: 8px 0 0;\n          }\n        }\n        .card-h {\n          border-top: 1px solid #cc9654;\n          border-bottom: none;\n          .card-content {\n            padding: 8px 0 0;\n          }\n        }\n      }\n    }\n    .card-image {\n      position: relative;\n      padding-top: 56.25%;\n      width: 150px;\n      height: 150px;\n      justify-content: center;\n      align-content: center;\n      display: inline-block;\n\n      .resolution-image {\n        border-radius: 5px;\n        position: absolute;\n        width: 100% !important;\n        height: 100% !important;\n        top: 0;\n        left: 0;\n      }\n    }\n    .card-item-image {\n      padding-right: 5px;\n      padding-top: 5px;\n    }\n    img {\n      padding: 5px;\n      border-radius: 50%;\n      width: 100%;\n      height: auto;\n      object-fit: cover;\n      object-position: center;\n      aspect-ratio: 16/9;\n      transform-origin: 50% 65%;\n      transition:\n        transform 2s,\n        filter 0.5s ease-out;\n      /* cls */\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n\n      border: 2px solid var(--primary-color);\n    }\n    /* -------------------------------- CONTENTS -------------------------------- */\n    .card-content {\n      top: 5px;\n      @media (max-width: 767px) {\n        margin: 10px 0 2.5px;\n      }\n    }\n    /* ---------------------------------- TITLE --------------------------------- */\n\n    .title {\n      position: relative;\n\n      font-size: 32px;\n      font-weight: 700;\n      color: #000;\n\n      &.title-h {\n        text-transform: capitalize;\n        &:hover {\n          color: var(--primary-color);\n        }\n      }\n      &.title-detail {\n        font-size: 20px;\n        font-weight: unset;\n      }\n    }\n\n    @media (max-width: 767px) {\n      min-height: 35px;\n      line-height: 1.35;\n      font-size: 16px;\n      display: flex;\n      flex-direction: row;\n    }\n    @media (max-width: 597px) {\n      min-height: 35px;\n      line-height: 1.35;\n      font-size: 16px;\n      padding: 20px;\n      justify-content: center;\n      align-content: center;\n      flex-direction: column-reverse !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  padding-bottom: 20px;\n  button {\n    width: 100%;\n    border: 1px solid #e3e3e3;\n    background-color: #e3e3e3;\n    color: #555555;\n    border-radius: 5px;\n    font-size: 18px;\n    padding: 5px 0;\n    :hover {\n      border: 1px solid #0600e7;\n      background-color: #0600e7;\n      color: #fff;\n      transition: background-color 0.8ms linear;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .empty-bg {\n    background: unset !important;\n  }\n  .heading-title {\n    font-size: 30pt;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n  }\n  .content-lists {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    margin-top: 25px;\n    @media (max-width: 690px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  .block-content {\n    .card-v-content-title {\n      font-size: 24pt !important;\n      font-family: 'DBHelvethaicaXBd', sans-serif !important;\n    }\n    @media (max-width: 690px) {\n      .card-v-content-title {\n        font-size: 20pt !important;\n      }\n      .card-h-content-title {\n        font-size: 16pt !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






















var PageError = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 31788)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31788)
            ];
        }
    }
});
var DynamicAds = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    }
});
var CardV = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40166)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40166)
            ];
        }
    }
});
var SectionAffiliate = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(6066), __webpack_require__.e(4929)]).then(__webpack_require__.bind(__webpack_require__, 34929)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34929)
            ];
        }
    }
});
var PageBylineDetail = function(param) {
    var articles = param.articles, nextArticles = param.nextArticles, category = param.category, subCategory = param.subCategory, meta = param.meta, ads = param.ads, dataAffiliate = param.dataAffiliate, dataAdsHeader = param.dataAdsHeader, dataBylines = param.dataBylines;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_15__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    if (articles === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageError, {
            dataAdsHeader: dataAdsHeader,
            sessionSevId: sessionSevId
        });
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var nextLinkRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(nextArticles);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(nextArticles), nextLink = ref[0], setNextLink = ref[1];
    var listArticlesRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(articles);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(articles), listArticles = ref1[0], setListArticles = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(24), show = ref2[0], setShow = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(true), adsBox = ref3[0], setAdsBox = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(true), isLoad = ref4[0], setIsLoad = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), loadData = ref5[0], setLoadData = ref5[1];
    var handleLightBoxClick = function() {
        setAdsBox(false);
    };
    var handleLoad = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
            var resData, ref, newLists, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadData(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(nextLinkRef.current && isLoad)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,src_utils_services__WEBPACK_IMPORTED_MODULE_20__/* .GET_ARTICLES */ .M)("".concat(nextLinkRef.current || ""), false, true)
                        ];
                    case 2:
                        resData = _state.sent();
                        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(resData === null || resData === void 0 ? void 0 : resData.data)) {
                            ;
                            nextLinkRef.current = (resData === null || resData === void 0 ? void 0 : resData.nextTo) || (resData === null || resData === void 0 ? void 0 : (ref = resData.links) === null || ref === void 0 ? void 0 : ref.next);
                            setNextLink(nextLinkRef.current);
                            newLists = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(listArticlesRef.current).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(resData === null || resData === void 0 ? void 0 : resData.data));
                            listArticlesRef.current = lodash_uniqBy__WEBPACK_IMPORTED_MODULE_4___default()(newLists, "id");
                            setListArticles(listArticlesRef.current);
                        }
                        _state.label = 3;
                    case 3:
                        setShow(show + 24);
                        setIsLoad(!isLoad);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error("".concat((0,src_utils_helper__WEBPACK_IMPORTED_MODULE_19__/* .timestamp */ .AB)(), " ==========> LOAD_BYLINES_LIST ERROR : ").concat(nextLinkRef === null || nextLinkRef === void 0 ? void 0 : nextLinkRef.current), err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoadData(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoad() {
            return _ref.apply(this, arguments);
        };
    }();
    var cloneListArticles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(listArticles);
    var baseUrlBylines = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, "/bylines/").concat(encodeURIComponent(dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.p_name));
    var _article = {
        title: (meta === null || meta === void 0 ? void 0 : meta.title) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_TITLE */ .qN,
        description: (meta === null || meta === void 0 ? void 0 : meta.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_DESC */ .a0,
        keyword: (meta === null || meta === void 0 ? void 0 : meta.keyword) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_KEYWORD */ .kG
    };
    var setItemListElement = '[\n        {\n          "@type": "ListItem",\n          "position": 1,\n          "name": "หน้าแรก",\n          "item": "'.concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, '"\n        },\n          {\n            "@type": "ListItem",\n            "position": 2,\n            "name": "Bylines",\n            "item": "').concat(baseUrlBylines, '"\n          }\n        ]');
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
                title: _article === null || _article === void 0 ? void 0 : _article.title,
                description: _article === null || _article === void 0 ? void 0 : _article.description,
                openGraph: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].openGraph */ .Z.openGraph), {
                    title: _article === null || _article === void 0 ? void 0 : _article.title,
                    description: _article === null || _article === void 0 ? void 0 : _article.description,
                    url: baseUrlBylines
                }),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: _article === null || _article === void 0 ? void 0 : _article.keyword
                    }
                ],
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "canonical",
                        href: baseUrlBylines
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:title",
                        content: _article === null || _article === void 0 ? void 0 : _article.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:description",
                        content: _article === null || _article === void 0 ? void 0 : _article.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:image",
                        content: src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .IMAGE_DEFAULT */ .TH
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                __th_page="'.concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.en) ? subCategory.en : category === null || category === void 0 ? void 0 : category.en, '";\n            ')
                        }
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_18__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_18__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "https://schema.org",\n                "@type": "WebSite",\n                "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_NAME */ .Ey, '",\n                "url": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.WEB */ .h$.WEB, '",\n                "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                "sameAs": [\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.TWITTER */ .h$.TWITTER, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.INSTAGRAM */ .h$.INSTAGRAM, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.YOUTUBE */ .h$.YOUTUBE, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.LINE */ .h$.LINE, '"\n                ],\n                "potentialAction": {\n                  "@type": "SearchAction",\n                  "target": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.WEB */ .h$.WEB, 'search?q={search_term_string}",\n                  "query-input": "required name=search_term_string"\n                }\n              }\n            ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                {\n                  "@context": "http://schema.org",\n                  "@type": "WebPage",\n                  "name": "'.concat(dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.p_name, '",\n                  "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                  "publisher": {\n                    "@type": "ProfilePage",\n                    "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_NAME */ .Ey, '"\n                  }\n                }\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "http://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": '.concat(setItemListElement, "\n              }\n            ")
                        }
                    })
                ]
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(dataAffiliate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionAffiliate, {
                position: 4,
                data: dataAffiliate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_layouts__WEBPACK_IMPORTED_MODULE_12__["default"], {
                sessionSevId: sessionSevId,
                children: [
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_16__.KEY_ADS_POSITION.LIGHTBOX,
                        data: ads,
                        handler: function() {
                            return handleLightBoxClick();
                        },
                        adsBox: adsBox
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_16__.KEY_ADS_POSITION.BILLBOARD,
                        data: ads
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionWrapper, {
                        id: "section-1",
                        className: "category-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionColumnist, {
                                    style: {
                                        filter: src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "block-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "card-item --desktop",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                                        className: "title line-clamp --2 title-h",
                                                        children: dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.p_name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "title line-clamp title-detail",
                                                        dangerouslySetInnerHTML: {
                                                            __html: dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.description
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "card-item-image",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "card-image",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_2_0_image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        src: (dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.image) ? "/uploads/images/md/" + (dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.image) : "/images/default.jpg",
                                                        title: dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.p_name,
                                                        size: src_2_0_image__WEBPACK_IMPORTED_MODULE_11__/* .IMAGE_SIZE.LG */ .W.LG
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        listArticles.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "no-article",
                                            style: {
                                                filter: src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_IMG */ .T, "/no-article.png"),
                                                alt: "no-article",
                                                width: "100%"
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "content-lists",
                                            style: {
                                                filter: src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: cloneListArticles.slice(0, show).map(function(item, index) {
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    id: index + 1,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardV, {
                                                        data: item,
                                                        description: false,
                                                        badge: true,
                                                        path: item.link,
                                                        //! DATALAYER
                                                        eventDataLayer: {
                                                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_17__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                            section: "ข่าวทั้งหมด",
                                                            position: "ใต้:โฆษณาตำแหน่ง billboard",
                                                            data: {
                                                                block: "1",
                                                                title: item.title,
                                                                heading: dataBylines === null || dataBylines === void 0 ? void 0 : dataBylines.p_name,
                                                                index: index + 6
                                                            }
                                                        }
                                                    })
                                                }, item.id);
                                            })
                                        }),
                                        nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonContainer, {
                                            style: {
                                                filter: src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: loadData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("text", {
                                                children: " Loading ... "
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                onClick: handleLoad,
                                                children: " ดูเพิ่มเติม"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            id: "postartice",
                                            className: "ads-sticky-overflow",
                                            children: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                                                position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_16__.KEY_ADS_POSITION.POSTARTICLE,
                                                data: ads
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_16__.KEY_ADS_POSITION.AD1X1,
                        data: ads
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageBylineDetail);
var SectionColumnist = styled_components__WEBPACK_IMPORTED_MODULE_27__["default"].div(_templateObject());
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_27__["default"].div(_templateObject1());
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_27__["default"].div(_templateObject2());


/***/ }),

/***/ 1903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ IMAGE_SIZE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);


var IMAGE_SIZE = {
    XS: "xs",
    XS_WEBP: "xs-webp",
    MD: "md",
    MD_WEBP: "md-webp",
    LG: "lg",
    LG_WEBP: "lg-webp",
    XL: "XL",
    XL_WEBP: "xl-webp",
    XXL: "XXL",
    XXL_WEBP: "xxl-webp"
};
var Image = function(param) {
    var _src = param.src, src = _src === void 0 ? "" : _src, alt = param.alt, title = param.title, _external = param.external, external = _external === void 0 ? false : _external, size = param.size, _externalLink = param.externalLink, externalLink = _externalLink === void 0 ? "" : _externalLink, _className = param.className, className = _className === void 0 ? "" : _className, width = param.width, height = param.height, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _decoding = param.decoding, decoding = _decoding === void 0 ? "async" : _decoding, fetchPriority = param.fetchPriority;
    var imgUrl = external ? externalLink ? "".concat(externalLink).concat(src) : "".concat(src) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_IMG */ .T).concat(src);
    var source = "".concat(imgUrl, "?x-image-process=style/").concat(size || "lg-webp");
    var altText = alt !== null && alt !== void 0 ? alt : title;
    var images = // display:block + width:100% so the img has a width to resolve against → its CSS aspect-ratio
    // can reserve space BEFORE the image loads (an inline <picture> collapses to 0 and causes CLS).
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        className: "resolution-image",
        style: {
            display: "block",
            width: "100%"
        },
        children: [
            !size && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(imgUrl, "?x-image-process=style/xs-webp"),
                media: "(max-width: 450px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(imgUrl, "?x-image-process=style/md-webp"),
                media: "(max-width: 690px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: source,
                media: "(min-width: 691px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: className,
                src: source,
                title: altText || "image",
                alt: altText,
                width: width,
                height: height,
                loading: loading,
                decoding: decoding,
                fetchPriority: fetchPriority
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "lazyload-wrapper",
        style: {
            width: "100%"
        },
        children: images
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GET; },
/* harmony export */   "M": function() { return /* binding */ GET_ARTICLES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);






// Service : GET ------------------------- */
function GET() {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    // If don't have data return [];
                    // If have data return [{ id: 1 }] or { data: [] }
                    // If can't call api return { data: null, msg: null }
                    // console.log(timestamp(), _url, ':');
                    if (!data.msg) {
                        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data.data)) {
                            return [
                                2,
                                all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data.data
                            ];
                        }
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat((0,_helper__WEBPACK_IMPORTED_MODULE_2__/* .timestamp */ .AB)(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET.apply(this, arguments);
}
function GET_ARTICLES() {
    return _GET_ARTICLES.apply(this, arguments);
}
function _GET_ARTICLES() {
    _GET_ARTICLES = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, _tmp2, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    if ((data === null || data === void 0 ? void 0 : data.statusCode) === 404) {
                        return [
                            2,
                            data
                        ];
                    } else if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data === null || data === void 0 ? void 0 : data.data)) {
                        return [
                            2,
                            all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data === null || data === void 0 ? void 0 : data.data
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp2, data) : []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat(new Date().toUTCString(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET_ARTICLES.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,7817,6126,106,9774,2888,179], function() { return __webpack_exec__(65182); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);